import { BASE_URL, post } from 'utils/sdk';

export type OnboardingManualStep = 'product' | 'share';

export const onboardingStepManualToggle = ({
  storeId,
  step,
  completed,
}: {
  storeId: number;
  step: OnboardingManualStep;
  completed: boolean;
}) => {
  return post<void>(`${BASE_URL}services/store/${storeId}/onboarding/step-manual-toggle/`, {
    step,
    completed,
  });
};
